var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHearts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 43,
    viewBox: "0 0 46 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1007 4.16799C35.981 -1.04256 25.0092 0.0742841 23 8.26168C20.9908 0.0742841 10.019 -1.04256 4.8993 4.16799C-0.128607 9.2851 -0.367029 17.2827 4.60859 22.3357C6.15789 23.9091 7.94041 25.5196 9.84311 27.2386L9.84312 27.2387C14.0482 31.0378 18.8403 35.3675 23 40.9999C27.1597 35.3674 31.9518 31.0378 36.1569 27.2386L36.157 27.2385C38.0597 25.5195 39.8421 23.9091 41.3914 22.3357C46.367 17.2827 46.1286 9.2851 41.1007 4.16799Z",
    stroke: "white",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHearts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hearts.7592c876.svg";